module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', _vm._g({
    ref: "reference",
    staticClass: "tooltip__reference"
  }, _vm.isTouchOnly ? {
    click: _vm.clickHandler
  } : {
    mouseenter: _vm.open,
    mouseleave: _vm.handleMouseLeave
  }), [_vm._t("reference", [_vm._v("\n      Tooltip Reference\n    ")])], 2), _vm._v(" "), _c('portal', {
    attrs: {
      "to": "popper-root"
    }
  }, [_c('div', _vm._g({
    key: "popper",
    ref: "popper",
    staticClass: "tooltip__popper"
  }, _vm.isTouchOnly ? undefined : {
    mouseenter: _vm.open,
    mouseleave: _vm.handleMouseLeave
  }), [_c('transition', {
    attrs: {
      "name": "message"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "tooltip__content"
  }, [_vm._t("content", [_vm._v("\n            Tooltip\n          ")])], 2) : _vm._e()])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6faf073e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Tooltip.vue
// module id = 443
// module chunks = 2